/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export const blobToFile = async (blob, fileName) => {
  const file = new File([blob], fileName, { type: blob.type })

  return file
}

export const getFileFromBlobUrl = async (blobUrl) => {
  const response = await fetch(blobUrl)
  const blob = await response.blob()

  return blob
}

export const bytesToMegaBytes = bytes => bytes / (1024 * 1024)

export const arrayBufferToBase64 = (buffer) => {
  if (!buffer) return ''

  // If it's already a string (base64), return it
  if (typeof buffer === 'string') return buffer

  // Handle ArrayBuffer or Buffer
  let bytes
  if (buffer instanceof ArrayBuffer) {
    bytes = new Uint8Array(buffer)
  } else if (buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
    // Handle Node.js Buffer format {type: 'Buffer', data: [...])}
    bytes = new Uint8Array(buffer.data)
  } else if (ArrayBuffer.isView(buffer)) {
    // Handle TypedArray views
    bytes = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength)
  } else {
    console.error('Unsupported buffer type:', buffer)
    return ''
  }

  // Convert bytes to base64 using chunks to avoid call stack size exceeded
  let binary = ''
  const chunkSize = 8192
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, Math.min(i + chunkSize, bytes.length))
    binary += String.fromCharCode.apply(null, chunk)
  }

  return btoa(binary)
}
